import { render, staticRenderFns } from "./DepositMoney.vue?vue&type=template&id=c5b67046&"
import script from "./DepositMoney.vue?vue&type=script&lang=js&"
export * from "./DepositMoney.vue?vue&type=script&lang=js&"
import style0 from "./DepositMoney.vue?vue&type=style&index=0&id=c5b67046&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports